export default __webpack_public_path__ + "static/media/02-beveiliging.af4f1144.png";